// Considered: NotificationSkeletonCardAtom — rejected: hardcodes the notification-card
// layout (avatar + two lines + footer), not a generic placeholder shape. This atom is
// the reusable PrimeReact `Skeleton` wrapper that card was itself built from. See spec
// Reuse Audit (studio-desk.md).
import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import './SkeletonAtom.scss';

export type SkeletonAtomShape = 'rectangle' | 'circle';

export interface SkeletonAtomProps {
  /** CSS width, e.g. '100%', '12rem'. Defaults to '100%'. */
  width?: string;
  /** CSS height, e.g. '1rem'. Defaults to '1rem'. */
  height?: string;
  shape?: SkeletonAtomShape;
  /** Render this many stacked skeleton lines instead of one. */
  count?: number;
  /** Gap between stacked lines when `count > 1`. */
  gap?: string;
  className?: string;
}

/**
 * SkeletonAtom - generic loading placeholder, wrapping PrimeReact's Skeleton.
 * Molecules/organisms must not import `primereact/skeleton` directly — compose
 * this atom instead (Rule 2, atomic-design.md).
 */
const SkeletonAtom: React.FC<SkeletonAtomProps> = ({
  width = '100%',
  height = '1rem',
  shape = 'rectangle',
  count = 1,
  gap = 'var(--spacing-xs)',
  className = '',
}) => {
  const lines = Array.from({ length: Math.max(1, count) }, (_, index) => (
    <Skeleton
      key={index}
      shape={shape}
      width={shape === 'circle' ? height : width}
      height={height}
      className={`skeleton-atom ${className}`}
    />
  ));

  if (lines.length === 1) {
    return lines[0];
  }

  return (
    <div className="skeleton-atom__stack" style={{ gap }}>
      {lines}
    </div>
  );
};

export default SkeletonAtom;
